import React, { FC, useState } from "react";
import { Table, Checkbox, Col, Dropdown, Modal } from "antd";
import "tailwindcss/tailwind.css";
import { EditOutlined, EllipsisOutlined } from "@ant-design/icons";
import { ItemType } from "antd/es/menu/interface";
import DetailsInfoes from "./DetailsInfoes";

const StatusList: FC<{ data: any; setData: any }> = ({ data, setData }) => {
  const [isShowChangedStatusModal, setIsShowChangedStatusModal] =
    useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  const handleCheckboxChange = (
    key: string,
    statusKey: keyof (typeof data)[0]["status"]
  ) => {
    setData((prevData: any) =>
      prevData.map((item: any) =>
        item.key === key
          ? {
              ...item,
              status: {
                orginal: false,
                localPainted: false,
                painted: false,
                changed: false,
                [statusKey]: true, // Seçilen durum `true`
              },
            }
          : item
      )
    );
  };

  const columns = [
    {
      title: "Parça",
      dataIndex: "parca",
      key: "parca",
    },
    {
      title: <span className="text-gray-500">Orijinal</span>,
      dataIndex: "orijinal",
      render: (_: any, record: any) => (
        <Checkbox
          checked={record.status.orginal}
          onChange={() => handleCheckboxChange(record.key, "orginal")}
        />
      ),
    },
    {
      title: <span className="text-orange-500">Lokal Boyalı</span>,
      dataIndex: "lokalBoyali",
      render: (_: any, record: any) => (
        <Checkbox
          checked={record.status.localPainted}
          onChange={() => handleCheckboxChange(record.key, "localPainted")}
        />
      ),
    },
    {
      title: <span className="text-blue-500">Boyalı</span>,
      dataIndex: "boyali",
      render: (_: any, record: any) => (
        <Checkbox
          checked={record.status.painted}
          onChange={() => handleCheckboxChange(record.key, "painted")}
        />
      ),
    },
    {
      title: <span className="text-red-500">Değişen</span>,
      dataIndex: "degisen",
      render: (_: any, record: any) => (
        <Checkbox
          checked={record.status.changed}
          onChange={() => handleCheckboxChange(record.key, "changed")}
        />
      ),
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "8%",
      render: (key: any, record: any) => (
        <Col className="text-end pr-2">
          <Dropdown menu={{ items: tableItemDropdownMenu(record) }}>
            <EllipsisOutlined className="text-xl" />
          </Dropdown>
        </Col>
      ),
    },
  ];
  const tableItemDropdownMenu = (record: any): ItemType[] => [
    {
      key: "1",
      onClick: async () => {
        await setSelectedRecord(record);
        setIsShowChangedStatusModal(true);
      },
      icon: <EditOutlined />,
      label: "Güncelle",
    },
  ];

  return (
    <>
      <Table
        bordered
        title={() => <strong>Parça Kontrol Tablosu</strong>}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
      {selectedRecord && (
        <>
          <Modal
            title=""
            open={isShowChangedStatusModal}
            onCancel={() => {
              setIsShowChangedStatusModal(false);
            }}
            footer={false}
          >
            <DetailsInfoes
              data={data}
              setData={setData}
              id={selectedRecord.key}
              title={selectedRecord.parca}
              onFinish={() => {
                setIsShowChangedStatusModal(false);
              }}
            />
          </Modal>
        </>
      )}
    </>
  );
};

export default StatusList;
